import styled from '@emotion/styled'
import { Text as UpstreamText } from 'spectacle'

const Text = styled(UpstreamText)`
  margin-top: 0.5em;
`

export default Text
